import React from "react";

const UserIn = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            className="u_fill"
            d="M18.968 21.962v11.672H4c0-1.84.417-3.655 1.222-5.306a12.035 12.035 0 013.418-4.223 11.939 11.939 0 014.917-2.277 11.9 11.9 0 015.41.134zm-2.994-1.886c-4.962 0-8.98-4.044-8.98-9.038C6.994 6.045 11.012 2 15.974 2c4.962 0 8.98 4.045 8.98 9.038 0 4.994-4.018 9.038-8.98 9.038zm11.103 6.026h5.367v3.013h-5.367l2.738 2.754L27.698 34l-6.35-6.392 6.35-6.391 2.117 2.131-2.738 2.754z"
            fill={fill}
        />
    </svg>
);

export default UserIn;